export const useSubdomain = (): string | null => {
    // Calcular directamente cada vez, es muy rápido y evita problemas de estado asíncrono
    const hostname = window.location.hostname;

    // Ignore localhost and IP addresses
    if (hostname.includes('localhost') || hostname.match(/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/)) {
        return null;
    }

    // Vercel Preview deployments
    if (hostname.endsWith('.vercel.app')) {
        return null;
    }

    const parts = hostname.split('.');

    if (parts.length >= 3) {
        const sub = parts[0];
        // Exclude common prefixes
        if (sub !== 'www' && sub !== 'app' && sub !== 'staging' && sub !== 'api') {
            return sub;
        }
    }

    return null;
};
